import { Inject } from '@odinjs/odin';

import { getFilterDates } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { FetchAPI, FieldAPI, FilterAPI, InputAPI, LocatorFieldAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnBlur, OnClear, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { ClearEvent, MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from './BaseController';

interface Origem {
  vlDominio: number,
}

@Controller({ fragment: 'pesquisa-utilizacao' })
export default class PesquisaUtilizacaoController extends BaseController {

  @Inject('fetch-procedimentos')
  private fetchProcedimentos: FetchAPI;

  @Inject('field-origem')
  private fieldOrigem: FieldAPI;

  @Inject('locator-field-codigo')
  private locatorFieldCodigo: LocatorFieldAPI;

  @Inject('input-codigo')
  private inputCodigo: InputAPI;

  @OnClear('filter-consulta')
  onClearFilter(event: ClearEvent): void {
    const api = event.target as unknown as FilterAPI;

    api.setData({});
    api.setData(getFilterDates('dtInicio', 'dtFim', 12));
  }

  @OnSubmit('filter-consulta')
  onSubmitFilter(event: SubmitEvent): void {
    const { record, target } = event;
    const api = target as unknown as FilterAPI;

    if (record && record.dtInicio && record.dtFim) {
      return;
    }

    const { dtInicio, dtFim } = getFilterDates('dtInicio', 'dtFim', 12);
    !record.dtInicio && (record.dtInicio = dtInicio);
    !record.dtFim && (record.dtFim = dtFim);

    api.setData({});
    api.setData({ ...api.getRecord(), dtInicio: record.dtInicio, dtFim: record.dtFim });
  }

  @OnBeforeFetch('fetch-dados-beneficiario')
  onBeforeFetchDadosBeneficiario(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

  @OnBeforeFetch('fetch-procedimentos')
  onBeforeFetchProcedimentos(): void {
    const { origem } = this.fieldOrigem.getData();
    const { vlDominio } = origem as Origem;
    origem && this.fetchProcedimentos.setParameters({ ...this.fetchProcedimentos.getParameters(), origem: vlDominio });
  }

  @OnBlur('field-origem')
  onBlurOrigem(): void {
    this.locatorFieldCodigo.setData({});
    this.inputCodigo.setValue('');
  }
}
